module.exports = __webpack_public_path__ + "static/media/email-icon.4ff81ff1.png";